/**
 * Labstep
 *
 * @module components/Group/Settings/Ordering
 * @desc Group settings for Ordering
 */

import { GroupTemplateOrderRequest as OrderRequestTemplate } from 'labstep-web/components/Group/Template/OrderRequest';
import { GroupTemplatePurchaseOrder as PurchaseOrderTemplate } from 'labstep-web/components/Group/Template/PurchaseOrder';
import { LayoutLinks } from 'labstep-web/components/Layout/Links';
import { Flex } from 'labstep-web/core/Flex';
import { PremiumFeatureScreenGuard } from 'labstep-web/core/PremiumFeature/ScreenGuard';
import { TagType } from 'labstep-web/models/tag.model';
import { TagIndex } from 'labstep-web/screens/Tag/Index';
import type React from 'react';
import type { GroupSettingsOrderingProps } from './types';

export const GroupSettingsOrdering: React.FC<
  GroupSettingsOrderingProps
> = ({ group }) => (
  <Flex column grow style={{ maxWidth: '800px' }}>
    <PremiumFeatureScreenGuard
      unstyled
      premiumFeature="order_management"
    >
      <LayoutLinks
        inverted
        links={[
          {
            children: 'Request Template',
            route: {
              to: 'group_settings_order_request_template',
              params: { id: group.id },
            },
            render: () => <OrderRequestTemplate group={group} />,
          },
          {
            children: 'Order Template',
            route: {
              to: 'group_settings_purchase_order_template',
              params: { id: group.id },
            },
            render: () => <PurchaseOrderTemplate group={group} />,
          },
          {
            children: 'Tags',
            route: {
              to: 'group_settings_order_request_tags',
              params: { id: group.id },
            },
            render: () => (
              <TagIndex group={group} type={TagType.order_request} />
            ),
          },
        ]}
      />
    </PremiumFeatureScreenGuard>
  </Flex>
);
